export { default } from './InfoMsg';
